export default __webpack_public_path__ + "static/media/exclusivo.def9e6de.png";